import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { users } from "../../../../../../redux/users/action";
import { selectUsersListItems } from "../../../../../../redux/users/selector";
import ResetPasswordModal from "../components/reset-modal.component";
import { deepCopy } from "../../../../../../common/services/common.service";

const ManagementUsers = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [selectedUserEmail, setSelectedUserEmail] = useState("");

  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const communitiesItems = useSelector(selectUsersListItems);

  const [columnDefs, setColumnDefs] = useState({});


  const createColumnDefs = () => {
    setColumnDefs([
      {
        field: "Sl",
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: "Sl",
        cellRenderer(params) {
          return parseInt(params.node.id, 10) + 1;
        },
      },
      { field: "FirstName", headerName: "First Name" },
      { field: "LastName", headerName: "Last Name" },
      { field: "UserType", headerName: "User Type" },
      { field: "Email", headerName: "Email" },
      { field: "PhoneNumber", headerName: "Phone Number" },
      { field: "City", headerName: "City" },
    ]);
  };

  const fetchCommunities = () => {
    dispatch(
      users.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/iam/users/list`,
        entity: "users",
        jsonData: {},
      })
    );
  };

  const handleReset = async (data) => {
    await dispatch(
      users.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/iam/token-service/send-reset-password-otp`,
        entity: "users",
        jsonData: {
          Records: [{ Email: data?.Email }],
        },
      })
    );

    setSelectedUserEmail(data?.Email);
    setResetModalOpen(true);
  };

  const handleFinalReset = async (payload) => {
    await dispatch(
      users.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/iam/token-service/reset-password`,
        entity: "users",
        jsonData: {
          Records: [
            {
              Email: payload.email,
              Otp: payload.otp,
              NewPassword: payload.newPassword,
              ConfirmPassword: payload.confirmPassword,
            },
          ],
        },
      })
    );

    setResetModalOpen(false);
    fetchCommunities();
  };

  const handleReloadData = () => {
    fetchCommunities();
  };

  const handleEdit = (data) => {
    navigate(`${data?.Id}`);
  };

  const handleDelete = (data) => {
    dispatch(
      users.delete({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/iam/users/delete`,
        entity: "users",
        jsonData: {
          Records: [{ Id: data?.Id }],
        },
      })
    ).then(() => {
      fetchCommunities();
    });
  };

  const additionButtons = [
    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          width="24"
          height="24"
        >
          <title>Reload</title>
          <path
            d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      callback: () => handleReloadData(),
    },
  ];

  useEffect(() => {
    createColumnDefs();
    fetchCommunities();
  }, [pageData, pageSize]);

  return (
    <>
      {communitiesItems?.isLoading ? (
        <PageLoader />
      ) : (
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: "Id",
          }}
          enableFilter={true}
          filterTypeLists={[
            { name: "Text", value: "text" },
            { name: "Number", value: "number" },
            { name: "CheckBox", value: "checkbox" },
            { name: "Date", value: "date" },
          ]}
          handleReset={handleReset}
          IsReset={true}
          columnData={columnDefs}
          rowData={communitiesItems?.result?.items}
          setPageData={setPageData}
          onDelete={handleDelete}
          onEdit={handleEdit}
          setPageSize={setPageSize}
          additionButtons={additionButtons}
          paginationData={communitiesItems?.result?.pagination}
          headingName="Users"
        />
      )}

      {/* Modal */}
      <ResetPasswordModal
        open={resetModalOpen}
        email={selectedUserEmail}
        onClose={() => {
          setResetModalOpen(false);
          fetchCommunities(); 
        }}
        onSubmit={handleFinalReset}
      />
    </>
  );
};

export default ManagementUsers;
